import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import localForage from 'localforage';
import { map } from 'rxjs';
import { isTokenExpired } from './is-token-expired.util';

export const getObservableTokenExpiredUtil = () => {
  return fromPromise(localForage.getItem<string>('token')).pipe(
    map((token) => {
      return isTokenExpired(token ?? '');
    })
  );
};
